import React from 'react';

import { Text } from '@mantine/core';

interface SectionNumberProps {
  number: number;
}

export function SectionNumber({ number }: SectionNumberProps) {
  return (
    <Text size="xs" fw={600} c="gray.7">
      {number}
    </Text>
  );
}
